const business = [
    {
        "source": {
            "id": "the-times-of-india",
            "name": "The Times of India"
        },
        "author": "TIMESOFINDIA.COM",
        "title": "Viral video: Major brawl at a Delhi store over delay in iPhone15 supply - Times of India Videos - Times of India",
        "description": "A viral video shows customers resorting to violence at a Delhi store due to a delay in iPhone 15 supply, prompting legal action by the Delhi Police. The launch of the iPhone 15 has generated immense enthusiasm, with even high prices failing to deter",
        "url": "https://timesofindia.indiatimes.com/videos/viral-videos/viral-video-major-brawl-at-a-delhi-store-over-delay-in-iphone15-supply/videoshow/103910809.cms",
        "urlToImage": "https://timesofindia.indiatimes.com/photo/msid-103910809,imgsize-.cms",
        "publishedAt": "2023-09-24T13:48:52Z",
        "content": null
    },
    {
        "source": {
            "id": null,
            "name": "Livemint"
        },
        "author": "Livemint",
        "title": "Govt mulls changes in IBC, insurers likely to get financial creditor status | Mint - Mint",
        "description": "The general insurance companies are seeking changes in the IBC to bring surety bonds at par with bank guarantees when it comes to recourse available to them in case of a default, the report said",
        "url": "https://www.livemint.com/news/india/govt-mulls-changes-in-ibc-insurers-likely-to-get-financial-creditor-status-11695561503073.html",
        "urlToImage": "https://www.livemint.com/lm-img/img/2023/09/24/600x338/MCA_1695561725123_1695561725341.jpg",
        "publishedAt": "2023-09-24T13:24:14Z",
        "content": "The Ministry of Corporate Affairs is looking at making relevant changes in the Insolvency and Bankruptcy Code (IBC) to consider insurers as financial creditor in case of default of infra projects, fo… [+2023 chars]"
    },
    {
        "source": {
            "id": "the-times-of-india",
            "name": "The Times of India"
        },
        "author": "TIMESOFINDIA.COM",
        "title": "Apple plans to boost production in India by over 5 times in 5 years - Times of India - IndiaTimes",
        "description": "India Business News: iPhone maker Apple is planning to boost its production in India by nearly five-fold to around $40 billion (Rs 3.32 lakh crore) in the next 4-5 years,",
        "url": "https://timesofindia.indiatimes.com/business/india-business/apple-plans-to-boost-production-in-india-by-over-5-times-in-5-years/articleshow/103908257.cms",
        "urlToImage": "https://static.toiimg.com/thumb/msid-103909551,width-1070,height-580,imgsize-21274,resizemode-75,overlay-toi_sw,pt-32,y_pad-40/photo.jpg",
        "publishedAt": "2023-09-24T12:21:00Z",
        "content": "FD Calculator\r\nWhen investing in a fixed deposit, the amount you deposit earns interest as per the prevailing...\r\nCalculate Now"
    },
    {
        "source": {
            "id": null,
            "name": "Gulte"
        },
        "author": "B.H Prasad",
        "title": "Elon Musk Confirms He’s Buying iPhone 15 - Gulte",
        "description": "The latest version of Apple's popular flagship cellular phone iPhone15 is here and already the mega phone maker is trying to make a huge buzz for the same. Especially Apple's CEO Tim Cook is trying to create huge attention for the phone as he shared some pict…",
        "url": "https://www.gulte.com/movienews/260603/elon-musk-confirms-hes-buying-iphone-15",
        "urlToImage": "https://cdn.gulte.com/wp-content/uploads/2023/09/image2.png",
        "publishedAt": "2023-09-24T12:16:11Z",
        "content": "The latest version of Apple’s popular flagship cellular phone iPhone15 is here and already the mega phone maker is trying to make a huge buzz for the same. Especially Apple’s CEO Tim Cook is trying t… [+1099 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Moneycontrol"
        },
        "author": "Moneycontrol News",
        "title": "ICICI Lombard appoints Sanjeev Mantri as new MD & CEO - Moneycontrol",
        "description": "On September 21, Bhargav Dasgupta left his role as MD and CEO after 14 years with the company to pursue an international career opportunity",
        "url": "https://www.moneycontrol.com/news/business/markets/icici-lombard-appoints-sanjeev-mantri-as-md-ceo-11418051.html",
        "urlToImage": "https://images.moneycontrol.com/static-mcnews/2023/09/stocks5-2-770x433.jpg",
        "publishedAt": "2023-09-24T12:10:21Z",
        "content": "ICICI Lombard General Insurance has announced the appointment of Sanjeev Mantri as Managing Director and Chief Executive Officer, according to a filing with the exchanges on September 24. Mantri pres… [+1687 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "News18"
        },
        "author": "Shahrukh Shah",
        "title": "Kia Seltos and Carens to Get a Price Hike From October, Details Inside - News18",
        "description": "Report Says the lower variants might see a price hike of around Rs 20,000. While the top models are likely to become costly by Rs 40,000.",
        "url": "https://www.news18.com/auto/kia-seltos-and-carens-to-get-a-price-hike-from-october-details-inside-8589225.html",
        "urlToImage": "https://images.news18.com/ibnlive/uploads/2023/07/new-project-1-2-53-168991340216x9.jpg",
        "publishedAt": "2023-09-24T12:10:00Z",
        "content": "The South Korean car manufacturer Kia recently updated its SUV and MPV lineup by adding the Seltos Facelift and Carens to the portfolio. Both the vehicles received an overwhelming response from the c… [+1487 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Moneycontrol"
        },
        "author": "Sunil Shankar Matkar",
        "title": "Trade setup for Monday: Top 15 things to know before the opening bell - Moneycontrol",
        "description": "A short build-up was seen in 71 stocks, including Shree Cement, Polycab India, Astral, UltraTech Cement, and JK Cement.",
        "url": "https://www.moneycontrol.com/news/business/markets/trade-setup-for-monday-top-15-things-to-know-before-the-opening-bell-60-11417571.html",
        "urlToImage": "https://images.moneycontrol.com/static-mcnews/2023/09/market_volatile-3-770x433.jpg",
        "publishedAt": "2023-09-24T11:49:13Z",
        "content": "The southward journey in the equity benchmarks continued for fourth consecutive session on September 22, especially immediately after hitting record high. Considering the breaking of 21-day EMA (expo… [+9464 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "The Indian Express"
        },
        "author": "The Indian Express",
        "title": "Deadline to add nominees for mutual fund investors, demat account holders ends on Sep 30 - The Indian Express",
        "description": null,
        "url": "https://indianexpress.com/article/business/market/deadline-add-nominees-mutual-fund-investors-demat-account-holders-8954032/",
        "urlToImage": null,
        "publishedAt": "2023-09-24T11:22:56Z",
        "content": null
    },
    {
        "source": {
            "id": "the-times-of-india",
            "name": "The Times of India"
        },
        "author": "TIMESOFINDIA.COM",
        "title": "'Even 1.4 billion people can't fill all empty homes': Former Chinese official on property crisis - IndiaTimes",
        "description": "With over 1.4 billion people, China is the second most populous country in the world today. Yet, even its staggering population will not be able to f",
        "url": "https://timesofindia.indiatimes.com/world/china/even-1-4-billion-people-cant-fill-all-empty-homes-former-chinese-official-on-property-crisis/articleshow/103907156.cms",
        "urlToImage": "https://static.toiimg.com/thumb/msid-103907936,width-1070,height-580,imgsize-110418,resizemode-75,overlay-toi_sw,pt-32,y_pad-40/photo.jpg",
        "publishedAt": "2023-09-24T10:42:00Z",
        "content": null
    },
    {
        "source": {
            "id": null,
            "name": "Newtraderu.com"
        },
        "author": "Steve Burns",
        "title": "7 Habits Of Billionaires - New Trader U",
        "description": "With their unparalleled success and influence, billionaires often become the subjects of admiration and study. While luck and timing play a role in success",
        "url": "https://www.newtraderu.com/2023/09/24/7-habits-of-billionaires/",
        "urlToImage": "https://www.newtraderu.com/wp-content/uploads/7-Habits-Of-Billionaires.jpg",
        "publishedAt": "2023-09-24T10:34:03Z",
        "content": "With their unparalleled success and influence, billionaires often become the subjects of admiration and study. While luck and timing play a role in success stories of their magnitude, many billionair… [+7612 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "GaadiWaadi.com"
        },
        "author": "Amit Rawat",
        "title": "New BMW iX1 Electric SUV Teased – To Be Launched Soon - GaadiWaadi.com",
        "description": "The New BMW iX1 is an all-electric SUV based on the 3rd gen X1, powered by a 64.7kWh battery with a range of 440km",
        "url": "https://gaadiwaadi.com/new-bmw-ix1-electric-suv-teased-to-be-launched-soon/",
        "urlToImage": "https://gaadiwaadi.com/wp-content/uploads/2023/09/bmw-iX1-2.jpg",
        "publishedAt": "2023-09-24T10:00:47Z",
        "content": "BMW has teased what could be one of its imminent launches, the iX1. The electric SUV could be launched in the coming week, here in India. The BMW iX1 is an EV based on the third generation X1. It is … [+1712 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "CNBCTV18"
        },
        "author": "Hormaz Fatakia",
        "title": "Suzlon Share Price: Here's why the stock will be in focus on Monday after orders rise to four-year high - CNBCTV18",
        "description": "In an exchange filing, Suzlon said that Ajay Mathur has been withdrawn from the board since the financial resistance granted by the REC-led consortium in terms of the rupee term loan agreement in April 2022 has been paid in full.",
        "url": "https://www.cnbctv18.com/market/stocks/suzlon-share-price-rec-withdraws-nominee-director-term-loan-repaid-in-full-2023-returns-17869211.htm",
        "urlToImage": "https://images.cnbctv18.com/wp-content/uploads/2019/06/Suzlon-1019x573.jpg",
        "publishedAt": "2023-09-24T09:54:14Z",
        "content": null
    },
    {
        "source": {
            "id": null,
            "name": "Livemint"
        },
        "author": "Saurav Mukherjee",
        "title": "RBI likely to maintain status quo on policy rates as inflation still high: Experts | Mint - Mint",
        "description": "On 8 February, 2023, the apex bank raised the benchmark repo rate to 6.5 percent and since then it has retained the rates at the same level",
        "url": "https://www.livemint.com/economy/rbi-likely-to-maintain-status-quo-on-policy-rates-as-inflation-still-high-experts-11695547523319.html",
        "urlToImage": "https://www.livemint.com/lm-img/img/2023/09/24/600x338/RBI_1695547654305_1695547654424.jpg",
        "publishedAt": "2023-09-24T09:28:54Z",
        "content": "At its bi-monthly monetary policy review meeting early next month, the Reserve Bank may keep the same policy rates for the fourth time in a row as retail inflation continues to remain high and the US… [+3738 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Livemint"
        },
        "author": "Nikita Prasad",
        "title": "The ‘Crude’ Question: Despite restricted supply, can oil sustain at $100/bbl? | Mint - Mint",
        "description": "Oil prices have now retreated to $93 per barrel as markets weighed supply concerns stemming from Russia's fuel export ban against demand woes from future rate hikes.",
        "url": "https://www.livemint.com/market/commodities/the-crude-question-despite-restricted-supply-can-oil-sustain-at-100bbl-11695482536059.html",
        "urlToImage": "https://www.livemint.com/lm-img/img/2023/09/23/600x338/oil_1695482552098_1695482552402.JPG",
        "publishedAt": "2023-09-24T09:26:08Z",
        "content": "International crude oil prices have rallied more than 10 per cent and sizzled to 10-month high levels after oil producers Saudi Arabia and Russia extended their voluntary output cuts of a combined 1.… [+5643 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "CNBCTV18"
        },
        "author": "Hormaz Fatakia",
        "title": "Trade Setup for September 25: Nifty 50 may see more volatility in F&O series expiry week - CNBCTV18",
        "description": "Even after last week's correction, the Nifty 50 is up nearly 450 points this series so far. The question is, will the expiry week manage to sustain those gains?",
        "url": "https://www.cnbctv18.com/market/trade-setup-september-25-nifty-50-expiry-week-levels-nifty-bank-today-bajaj-finance-sjvn-hdfc-17868321.htm",
        "urlToImage": "https://images.cnbctv18.com/wp-content/uploads/2023/05/TRADE_SETUP_BG-1019x573.jpg",
        "publishedAt": "2023-09-24T09:05:28Z",
        "content": null
    },
    {
        "source": {
            "id": null,
            "name": "Livemint"
        },
        "author": "Livemint",
        "title": "Plaza Wires IPO: Know price band, subscription date, other details | Mint - Mint",
        "description": "Delhi-based Plaza Wires sets price band for IPO at  ₹51-54 per share to raise funds for expansion and operational needs.",
        "url": "https://www.livemint.com/market/ipo/plaza-wires-ipo-know-price-band-subscription-date-other-details-11695538355837.html",
        "urlToImage": "https://www.livemint.com/lm-img/img/2023/09/24/600x338/Plaza_Wires_1695542039490_1695542040016.jpg",
        "publishedAt": "2023-09-24T07:55:44Z",
        "content": "Delhi-based Plaza Wires has set a price band of 51-54 a share for its 71.30 crore initial public offering (IPO). According to a report by Moneycontrol, the IPO will open for anchor investors on 27 Se… [+2271 chars]"
    },
    {
        "source": {
            "id": "the-times-of-india",
            "name": "The Times of India"
        },
        "author": "ET Online",
        "title": "Why big global investors can't get enough of Adani Green Energy - The Economic Times",
        "description": "Explaining the rationale behind the investment flow, sources said India is now a leader in the renewable energy space, with many solar and wind projects in the pipeline. Adani is the largest renewable power producer in India, and with its strong execution abi…",
        "url": "https://economictimes.indiatimes.com/industry/renewables/everyone-wants-a-pie-of-indias-largest-renewable-power-producer/articleshow/103904888.cms",
        "urlToImage": "https://img.etimg.com/thumb/msid-103904969,width-1200,height-630,imgsize-45052,overlay-economictimes/photo.jpg",
        "publishedAt": "2023-09-24T07:41:00Z",
        "content": "It looks like big global investors can't get enough of Adani Green Energy Ltd (AGEL), India's largest renewable power producer.French giant TotalEnergies SE's $300 million investment in clean energy … [+3015 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Cardekho.com"
        },
        "author": "Shreyash",
        "title": "New Hyundai i20 Facelift vs Old: Key Differences Explained - CarDekho",
        "description": "The design changes on the i20 facelift are subtle, though the powertrain options have been rejigged.  The Hyundai i20 facelift has already gone on sale in India featuring minor styling tweaks and rejigged powertrain options. It is available in five broad vari…",
        "url": "https://www.cardekho.com/india-car-news/new-hyundai-i20-facelift-vs-old-key-differences-explained-31484.htm",
        "urlToImage": "https://stimg2.cardekho.com/images/carNewsimages/userimages/650X420/31483/1695542945210/GeneralNew.jpg",
        "publishedAt": "2023-09-24T07:39:00Z",
        "content": "The design changes on the i20 facelift are subtle, though the powertrain options have been rejigged.\r\nThe Hyundai i20 facelift has already gone on sale in India featuring minor styling tweaks and rej… [+2906 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Moneycontrol"
        },
        "author": "Moneycontrol News",
        "title": "Maruti Suzuki joins hands with Indian Navy for Northeast outreach - Moneycontrol",
        "description": "A 6,500-km long expedition was launched for the Indian Navy's base in Lonavala, with 45 officers participating in the journey",
        "url": "https://www.moneycontrol.com/news/business/maruti-suzuki-joins-hands-with-indian-navy-for-northeast-outreach-programme-11416681.html",
        "urlToImage": "https://images.moneycontrol.com/static-mcnews/2023/09/Media-Release_MSIL-x-Indian-Navy-770x433.jpg",
        "publishedAt": "2023-09-24T07:06:25Z",
        "content": "Maruti Suzuki, Indias biggest carmaker, on September 24 announced a partnership with the Indian Navy to raise awareness about career opportunities among the youth in the Northeast through \"Khamree Mo… [+1822 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Moneycontrol"
        },
        "author": "PTI",
        "title": "After BPCL, ONGC signs up HPCL for sale of oil from Mumbai offshore fields - Moneycontrol",
        "description": "Last month, ONGC had signed a similar pact to sell 4 million tonnes per annum plus an optional 0.5 million tonnes of crude oil to BPCL, which too has a refinery to convert the crude oil into fuels like petrol and diesel at Mumbai.",
        "url": "https://www.moneycontrol.com/news/business/after-bpcl-ongc-signs-up-hpcl-for-sale-of-oil-from-mumbai-offshore-fields-11416661.html",
        "urlToImage": "https://images.moneycontrol.com/static-mcnews/2019/05/ONGC-India-770x433.jpg",
        "publishedAt": "2023-09-24T06:37:48Z",
        "content": "State-owned Oil and Natural Gas Corporation (ONGC) has signed an agreement to sell crude oil it produces from Mumbai offshore fields to HPCL the second such agreement in as many months, as India's to… [+3412 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Dsij.in"
        },
        "author": "Praveenkumar Yadav",
        "title": "700 per cent returns: This multibagger rail infrastructure company bags multiple order worth Rs 1517.69 crore! - Dalal Street Investment Journal",
        "description": "Shares of the company have gained about 150 per cent in the last six months.",
        "url": "https://www.dsij.in/dsijarticledetail/700-per-cent-returns-this-multibagger-rail-infrastructure-company-bags-multiple-order-worth-rs-151769-crore-33406-1",
        "urlToImage": "https://www.dsij.in/Portals/0/EasyDNNnews/33406/image_2419.jpg",
        "publishedAt": "2023-09-24T06:26:00Z",
        "content": "Shares of the company have gained about 150 per cent in the last six months.\r\nRail Vikas Nigam Limited informed in the exchange filing that the company has signed an MoU with the National Highways Au… [+1788 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Livemint"
        },
        "author": "Livemint",
        "title": "Vietjet expands India services with Tiruchirappalli-Ho Chi Minh City route set for November | Mint - Mint",
        "description": "Vietnam's Vietjet plans to introduce a new route between Tiruchirappalli in India and Ho Chi Minh City in November to meet increasing demand from Indian tourists. The airline already operates 32 round-trip flights to and from India each week.",
        "url": "https://www.livemint.com/companies/news/vietjet-expands-india-services-with-tiruchirappalli-ho-chi-minh-city-route-set-for-november-11695532364348.html",
        "urlToImage": "https://www.livemint.com/lm-img/img/2023/09/24/600x338/2-0-838641751-RTX13YOI-0_1679657893566_1695534646691.jpg",
        "publishedAt": "2023-09-24T06:09:23Z",
        "content": "Vietjet, Vietnam's largest private airline, is gearing up to meet the increasing demand from Indian tourists who are increasingly considering Vietnam as an emerging travel destination. As reported by… [+3539 chars]"
    },
    {
        "source": {
            "id": "the-times-of-india",
            "name": "The Times of India"
        },
        "author": "PTI",
        "title": "FPI outflow in equities crosses Rs 10,000 cr mark in Sept on rising US interest rates - The Economic Times",
        "description": "Mayank Mehra, smallcase, manager and principal partner at Craving Alpha,believes that strong economic growth prospects, attractive valuations, and government reforms could support foreign investment flows in the next month.",
        "url": "https://economictimes.indiatimes.com/markets/stocks/news/fpis-outflow-in-equities-crosses-rs-10000-cr-mark-in-sep-on-rising-us-interest-rates/articleshow/103903182.cms",
        "urlToImage": "https://img.etimg.com/thumb/msid-103903209,width-1200,height-630,imgsize-17514,overlay-etmarkets/photo.jpg",
        "publishedAt": "2023-09-24T06:08:00Z",
        "content": "Foreign Portfolio Investors (FPIs) have pulled out over Rs 10,000 crore from Indian equities in the first three weeks of September, primarily due to rising US interest rates, recessionary fears, and … [+2640 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "GaadiWaadi.com"
        },
        "author": "Surendhar M",
        "title": "Ather Plans To Launch New e-Scooters & e-Motorcycles In India - GaadiWaadi.com",
        "description": "Ather is currently planning to launch two new electric scooters before the end of the next financial year in India",
        "url": "https://gaadiwaadi.com/ather-plans-to-launch-new-e-scooters-e-motorcycles-in-india/",
        "urlToImage": "https://gaadiwaadi.com/wp-content/uploads/2020/06/Ather-Electric-Motorcycle-Rendering-10.jpg",
        "publishedAt": "2023-09-24T05:30:47Z",
        "content": "While Ola Electric is planning to launch a whole new range of electric motorcycles previewed last month, one of its main rivals, Ather Energy is buoyed by fresh investment of USD 108 million from Her… [+1856 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Onmanorama.com"
        },
        "author": "P Kishore",
        "title": "Reserve Bank set to cancel KTDFC’s licence | Kerala News | Onmanorama - Onmanorama",
        "description": "The banking regulator's action was triggered by KTDFC's inability to repay Rs 130 crore to Sri Ramakrishna Mission based in Kolkata, even months after the expiry of its term.",
        "url": "https://www.onmanorama.com/news/kerala/2023/09/24/reserve-bank-of-indio-rbi-cancels-ktdfc-licence.html",
        "urlToImage": "https://img.onmanorama.com/content/dam/mm/en/news/business/images/2022/8/26/rbi.jpg",
        "publishedAt": "2023-09-24T05:15:00Z",
        "content": "Kochi: The Reserve Bank of India (RBI), through a special emissary, has informed the state government that it would revoke the non-banking licence of the Kerala Transport Development Finance Corporat… [+1285 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Livemint"
        },
        "author": "PTI",
        "title": "Markets outlook: Global trends, foreign investors' trading to decide D-street action | Mint - Mint",
        "description": "Global trends, foreign investor activity, and Brent crude movement will impact domestic markets this week. Markets may face volatility due to monthly derivatives expiry.",
        "url": "https://www.livemint.com/market/stock-market-news/markets-outlook-global-trends-foreign-investors-trading-to-decide-d-street-action-11695530968212.html",
        "urlToImage": "https://www.livemint.com/lm-img/img/2023/09/24/600x338/dalaal_street-BSE_1695531914161_1695531915934.jpg",
        "publishedAt": "2023-09-24T05:10:14Z",
        "content": "Global trends, trading activity of foreign investors and movement of oil benchmark Brent crude would dictate terms in the domestic markets this week, analysts said. Equity markets, which fell nearly … [+2691 chars]"
    },
    {
        "source": {
            "id": "the-times-of-india",
            "name": "The Times of India"
        },
        "author": "PTI",
        "title": "8 of top 10 firms lose Rs 2.28 lakh crore in mcap; HDFC Bank, Reliance biggest laggards - IndiaTimes",
        "description": "The market valuation of HDFC Bank plummeted by Rs 99,835.27 crore to Rs 11,59,154.60 crore. Shares of the company fell by nearly 8 per cent last week.",
        "url": "https://timesofindia.indiatimes.com/business/india-business/eight-of-top-10-firms-lose-rs-2-28-lakh-crore-in-mcap-hdfc-bank-reliance-biggest-laggards/articleshow/103901403.cms",
        "urlToImage": "https://static.toiimg.com/thumb/msid-103901467,width-1070,height-580,imgsize-61898,resizemode-75,overlay-toi_sw,pt-32,y_pad-40/photo.jpg",
        "publishedAt": "2023-09-24T04:53:00Z",
        "content": "8 types of apples and their hidden health benefits"
    },
    {
        "source": {
            "id": null,
            "name": "Hindustan Times"
        },
        "author": "Anirudh Bhattacharyya",
        "title": "India-Canada row: Visa suspension will not affect OCI services, says official - Hindustan Times",
        "description": "India has suspended visa services for Canadian citizens citing security threats to its staff in its consulates in Canada | Latest News India",
        "url": "https://www.hindustantimes.com/india-news/indiacanada-row-visa-suspension-will-not-affect-oci-services-says-official-101695530027980.html",
        "urlToImage": "https://www.hindustantimes.com/ht-img/img/2023/09/24/1600x900/High-Commission-of-Canada-in-New-Delhi--India--Rep_1695530020232.jpg",
        "publishedAt": "2023-09-24T04:33:47Z",
        "content": "India may have suspended visa services for Canadian nationals, applications for issuance of fresh Overseas Citizen of India or OCI have not been impacted.\r\nHigh Commission of Canada in New Delhi, Ind… [+2541 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "News18"
        },
        "author": "Namit Singh Sengar",
        "title": "Gold Rate Falls Today: Check Latest 24 Carat Price In Your City On September 24 - News18",
        "description": "Gold rate today: Check gold prices today in different cities on September 24, 2023.",
        "url": "https://www.news18.com/business/gold-rate-today-mumbai-delhi-22kt-18-carat-hallmark-8589159.html",
        "urlToImage": "https://images.news18.com/ibnlive/uploads/2023/05/gold-women-168378618916x9.jpeg",
        "publishedAt": "2023-09-24T04:10:09Z",
        "content": "Gold Rate Today In India: As of September 24th, the retail rates for 10 grams of gold vary across various cities, with an approximate price of Rs 60,000. To offer a more comprehensive breakdown, 10 g… [+3084 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Staffnews.in"
        },
        "author": "Kiran Kumari",
        "title": "NPS Tier II through Default scheme for Government Sector Subscribers - Additional investment option: PFRDA Circular dated 22.09.2023 | StaffNews - Staff News",
        "description": "NPS Tier II through Default scheme for Government Sector Subscribers - Additional investment option with flexibility and convenience, aligning with the unique",
        "url": "https://www.staffnews.in/2023/09/nps-tier-ii-through-default-scheme-for-government-sector-subscribers.html",
        "urlToImage": "https://www.staffnews.in/wp-content/uploads/2022/10/national-pension-system-new-pension-scheme-nps-e1668562607241.jpg",
        "publishedAt": "2023-09-24T03:53:03Z",
        "content": "NPS Tier II through Default scheme for Government Sector Subscribers – Additional investment option with flexibility and convenience, aligning with the unique requirements: PFRDA Circular dated 22.09… [+3511 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Hindustan Times"
        },
        "author": "PTI",
        "title": "Tata Motors inaugurates registered vehicle scrapping facility in Surat - Hindustan Times",
        "description": "Named Re.Wi.Re – Recycle with Respect,' facility uses environmentally-friendly processes and has capacity to disassemble 15,000 end-of-life vehicles per year.",
        "url": "https://www.hindustantimes.com/car-bike/tata-motors-inaugurates-registered-vehicle-scrapping-facility-in-surat-101695525627967.html",
        "urlToImage": "https://www.hindustantimes.com/ht-img/img/2023/09/24/1600x900/tata_motors_1695525665042_1695525665208.jpg",
        "publishedAt": "2023-09-24T03:25:38Z",
        "content": "India's leading automobile manufacturer Tata Motors on Saturday inaugurated its third registered vehicle scrapping facility (RVSF) in Surat with a capacity to recycle 15,000 vehicles per year.\r\nThe R… [+1179 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Moneycontrol"
        },
        "author": "Sunil Shankar Matkar",
        "title": "Daily Voice | PSU banks challenging dominance of private sector, says Alok Jain of Weekend Investing - Moneycontrol",
        "description": "The renewed interest in these banks is also the outcome of the government's push towards privatisation and operational efficiency. The elevated prices are a precursor to their anticipated future earnings, says Jain",
        "url": "https://www.moneycontrol.com/news/business/markets/daily-voice-psu-banks-challenging-dominance-of-private-sector-says-alok-jain-of-weekend-investing-11415971.html",
        "urlToImage": "https://images.moneycontrol.com/static-mcnews/2023/09/Alok_Jain_Smallcase-770x433.jpg",
        "publishedAt": "2023-09-24T03:04:23Z",
        "content": "The state-owned bank pack has been on a tear, with the Nifty PSU bank index surging 46 percent in the past six months. Alok Jain, smallcase manager &amp; the founder of Weekend Investing, says these … [+6354 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "CNBCTV18"
        },
        "author": "Sonal Sachdev",
        "title": "Bottomline | Making sense of the GST claim on Delta Corp - CNBCTV18",
        "description": "Why the near Rs 17,000 crore GST demand on Delta Corp sounds incredulous but there could be areas of grey",
        "url": "https://www.cnbctv18.com/finance/bottomline--making-sense-of-the-gst-claim-on-delta-corp-17867901.htm",
        "urlToImage": "https://images.cnbctv18.com/wp-content/uploads/2022/05/GST-1000x573.jpg",
        "publishedAt": "2023-09-24T02:42:25Z",
        "content": null
    },
    {
        "source": {
            "id": null,
            "name": "Dsij.in"
        },
        "author": "Mandar Wagh",
        "title": "IPO Analysis: JSW Infrastructure Ltd - Dalal Street Investment Journal",
        "description": "IPO Rating: Apply for the long-term",
        "url": "https://www.dsij.in/dsijarticledetail/ipo-analysis-jsw-infrastructure-ltd-33402-1",
        "urlToImage": "https://www.dsij.in/Portals/0/EasyDNNnews/33402/image_279.jpg",
        "publishedAt": "2023-09-24T02:26:35Z",
        "content": "IPO Rating: Apply for the long-term \r\nAbout the Issue: \r\nJSW Infrastructure, a pivotal component of the JSW Group, provides a wide range of maritime-related services, including cargo handling, storag… [+6456 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "CarToq.com"
        },
        "author": "Kshitij Bisen, Vikas Kaul",
        "title": "Maruti Suzuki Fronx vs Nissan Magnite: Comparing Their Variants Under Rs 10 Lakh for Family-focused Car Buyers - CarToq.com",
        "description": "As a family man, you consider only the best family cars in India when deciding on which one to buy. Today, let’s look at the compact SUVs Maruti Suzuki Fronx and the Nissan Magnite, and find out what makes them family-friendly car models in India. In this art…",
        "url": "https://www.cartoq.com/buying-advice/maruti-suzuki-fronx-vs-nissan-magnite-comparing-their-variants-under-rs-10-lakh-for-family-focused-car-buyers/",
        "urlToImage": "https://www.cartoq.com/wp-content/uploads/2023/09/Maruti-Suzuki-Fronx-vs-Nissan-Magnite.jpg",
        "publishedAt": "2023-09-24T00:45:25Z",
        "content": "As a family man, you consider only the best family cars in India when deciding on which one to buy. Today, lets look at the compact SUVs Maruti Suzuki Fronx and the Nissan Magnite, and find out what … [+6439 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "The Indian Express"
        },
        "author": "The Indian Express",
        "title": "Amid supply risks, Tata Motors cuts rare earth use in new EV by a third - The Indian Express",
        "description": null,
        "url": "https://indianexpress.com/article/auto-travel/amid-supply-risks-tata-motors-cuts-rare-earth-use-in-new-ev-by-a-third-8953310/",
        "urlToImage": null,
        "publishedAt": "2023-09-23T22:23:51Z",
        "content": null
    },
    {
        "source": {
            "id": null,
            "name": "Cgtn.com"
        },
        "author": "CGTN",
        "title": "UAW strike expands to 38 locations in 20 U.S. states - newsus.cgtn.com",
        "description": "The strike by U.S. auto workers is expanding to include dozens of new facilities across the country. This comes as union leaders say they're making progress with Ford, but talks with GM and Stellantis have stalled.&nbsp;CGTN's Jim Spellman reports.For",
        "url": "https://newsus.cgtn.com/news/2023-09-24/UAW-strike-expands-to-38-locations-in-20-U-S-states-1nloFhtwTde/index.html",
        "urlToImage": "https://newsus.cgtn.com/news/2023-09-24/UAW-strike-expands-to-38-locations-in-20-U-S-states-1nloFhtwTde/img/89c5036bd92a40c49f53586b7a7de5da/89c5036bd92a40c49f53586b7a7de5da-1280.jpeg",
        "publishedAt": "2023-09-23T19:34:51Z",
        "content": "The strike by U.S. auto workers is expanding to include dozens of new facilities across the country. This comes as union leaders say they're making progress with Ford, but talks with GM and Stellanti… [+158 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "CarToq.com"
        },
        "author": "Utkarsh Deshmukh",
        "title": "Chandigarh to stop registration of ICE two-wheelers and four-wheelers from October and December - CarToq.com",
        "description": "In a significant move towards promoting a cleaner and greener environment, the Union Territory (UT) administration in Chandigarh has taken decisive steps to limit the registration of internal combustion engine (ICE) vehicles, including both two-wheelers and f…",
        "url": "https://www.cartoq.com/chandigarh-to-stop-registration-of-ice-two-wheelers-and-four-wheelers-from-october-and-december/",
        "urlToImage": "https://www.cartoq.com/wp-content/uploads/2023/03/ather-electric-scooter-charging-station.jpg",
        "publishedAt": "2023-09-23T19:20:15Z",
        "content": "In a significant move towards promoting a cleaner and greener environment, the Union Territory (UT) administration in Chandigarh has taken decisive steps to limit the registration of internal combust… [+3337 chars]"
    }
]

export default business;